import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get_payment_request_details } from "../../DAL/PaymentRequest/paymentRequest";
import CircularLoader from "../../components/loader/CircularLoader";
import RequestCard from "./RequestCard";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TransactionsTable from "./TransactionsTable";
import moment from "moment";

export default function PaymentRequestsDetails() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();

  function test(words) {
    var n = words.split("=");
    return n[n.length - 1];
  }
  let mobileView = test(location.search);
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [paymentRequestDetails, setPaymentRequestDetails] = useState();
  const [transactions, setTransactions] = useState([]);
  const getRequestDetail = async () => {
    const result = await get_payment_request_details(params.id);
    if (result.code === 200) {
      setPaymentRequestDetails(result.data.payment_request);
      let transactionsArray = result.data.transaction.map((obj) => {
        return {
          ...obj,
          amount: obj.total_amount,
          currency: obj.currency,
          date: moment(obj.createdAt).format("ll"),
          clientName: obj?.member_info?.name || "",
          clientEmail: obj?.member_info?.email || "",
        };
      });
      setTransactions([...transactionsArray]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const promises = []; // always run this

        promises.push(getRequestDetail()); // run only if state is not provided
        if (state) {
          setPaymentRequestDetails(state); // use state directly
        }

        await Promise.all(promises); // wait for all
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <>
      <div className="container mt-2">
        <div className="d-flex align-items-center mb-2">
          {mobileView == "mobile" ? (
            ""
          ) : (
            <span>
              <IconButton
                className="back-screen-button"
                onClick={() => navigate("/payment-requests")}
              >
                <ArrowBackIcon />
              </IconButton>
            </span>
          )}
          <h3 className="mb-0 ms-2">Payment Request Details</h3>
        </div>

        <RequestCard
          bill={paymentRequestDetails}
          showChargeAbleAmount={false}
          isDetailShow={true}
        />
        <h3 className="mb-3 ms-2">Transactions</h3>

        <TransactionsTable transactions={transactions} />
      </div>
    </>
  );
}
